const restrictions = [
  'CAN_BE_ORDERED_WITH_ATTEST',
  'CAN_NOT_BE_ORDERED',
  'CAN_BE_ORDERED'
]

const withKeys = () => {
  return restrictions.map(item => {
    return {
      label: item,
      key: `bms.media.tagsMenu.specific.${item}`
    }
  })
}

export default withKeys



// WEBPACK FOOTER //
// ./src/utils/getRestrictions.js